import axios from 'axios';
import { useMutation, useQuery } from 'react-query';
import { API_URL, securityHeaders } from '../Constants';

const encodePath = (v) => encodeURIComponent(String(v ?? ''));
const encodeQuery = (v) => encodeURIComponent(String(v ?? '').trim());

const withoutJsonContentType = (headers) => {
  const h = { ...(headers || {}) };
  delete h['Content-Type'];
  delete h['content-type'];
  return h;
};

const withBearer = (baseHeaders = securityHeaders) => {
  const token = localStorage.getItem('token');
  return {
    ...(baseHeaders || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

const fetchGraduationStatistics = async (search = '') => {
  const q = search ? `?search=${encodeQuery(search)}` : '';
  return axios.get(API_URL + `/api/Graduation/GetGraduationStatistics${q}`, {
    headers: withBearer(securityHeaders),
  });
};

export const useFetchGraduationStatistics = (search = '') => {
  return useQuery({
    queryKey: ['graduationStatistics', search],
    queryFn: () => fetchGraduationStatistics(search),
    enabled: true,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });
};

const saveGraduationStatistics = async (data) => {
  const isFormData =
    typeof FormData !== 'undefined' && data instanceof FormData;

  const base = isFormData
    ? withoutJsonContentType(securityHeaders)
    : securityHeaders;

  return axios.post(API_URL + '/api/Graduation/Statistics', data, {
    headers: withBearer(base),
  });
};

export const useSaveGraduationStatistics = () => {
  return useMutation(saveGraduationStatistics);
};

const deleteGraduationStatistics = async (graduationStatisticsId) => {
  if (!graduationStatisticsId)
    throw new Error('Missing graduationStatisticsId');

  return axios.post(
    API_URL +
      `/api/Graduation/DeleteGraduationStatistics/${encodePath(
        graduationStatisticsId
      )}`,
    null,
    {
      headers: withBearer(securityHeaders),
    }
  );
};

export const useDeleteGraduationStatistics = () => {
  return useMutation(deleteGraduationStatistics);
};
